<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form v-on:keypress.enter.prevent="searchData(1)" class="form-inline my-2 my-lg-0">
                    <input
                        class="form-control mr-sm-2"
                        v-model="search.keyword"
                        type="search"
                        placeholder="รหัสเจ้าหนี้"
                        aria-label="Search"/>
                    <button
                        class="btn btn-success my-2 my-sm-0"
                        type="button"
                        @click="searchData(1)">
                        <icon name="search"></icon> ค้นหา
                    </button>
                    &nbsp;&nbsp;
                    <template v-if="canCustomerVendorsCreate">
                        <router-link to="vendor-information">
                            <button class="btn btn-warning my-2 my-sm-0" type="button">
                                <icon name="plus"></icon> เพิ่มเจ้าหนี้
                            </button>
                        </router-link>
                    </template>
                </form>
            </div>
        </nav>
        <!-- table -->
        <div class="col-12 table-responsive">
            <table style="text-align: center" class="table table-bordered">
                <thead>
                <tr>
                    <th scope="col">รหัสเจ้าหนี้</th>
                    <th scope="col">ชื่อ-นามสกุล</th>
                    <th scope="col">ที่อยู่</th>
                    <th scope="col">เบอร์โทรศัพท์</th>
                    <th scope="col">อีเมลล์</th>
                    <th scope="col">ดูใบเสนอราคา</th>
                    <th scope="col">แก้ไข / ลบ</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="data in vendorList">
                    <td>{{data.vendor_id}}</td>
                    <td>{{data.first_name}} {{data.last_name}}</td>
                    <td>{{data.address}}</td>
                    <td>{{data.phone}}</td>
                    <td>{{data.email}}</td>

                    <td>
                        <div v-if="data.quotation_file_1">
                            <a :href="data.quotation_file_1" target="_blank">
                                <icon name="file-alt" style="width: 25px"></icon>
                                ดูใบเสนอราคา1
                            </a>
                        </div>
                        <div v-if="data.quotation_file_2">
                            <a :href="data.quotation_file_2" target="_blank">
                                <icon name="file-alt" style="width: 25px"></icon>
                                ดูใบเสนอราคา2
                            </a>
                        </div>
                        <div v-if="data.quotation_file_3">
                            <a :href="data.quotation_file_3" target="_blank">
                                <icon name="file-alt" style="width: 25px"></icon>
                                ดูใบเสนอราคา3
                            </a>
                        </div>
                        <div v-if="data.quotation_file_4">
                            <a :href="data.quotation_file_4" target="_blank">
                                <icon name="file-alt" style="width: 25px"></icon>
                                ดูใบเสนอราคา4
                            </a>
                        </div>
                        <div v-if="data.quotation_file">
                            <a :href="data.quotation_file" target="_blank">
                                <icon name="file-alt" style="width: 25px"></icon>
                                ดูใบเสนอราคา5
                            </a>
                        </div>
                    </td>
                    <td>
                        <a @click="updateData(data.id)">
                            <icon name="pencil-alt"></icon>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div>
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getVendorPage">
            </vue-pagination>
        </div>
        <br>
        <!-- <pre class="alert alert-primary">{{ Seller }}</pre> -->
    </div>
</template>

<script>
import { mapState } from "vuex";
import VuePagination from "../../Pagination";
import {
    canCustomerVendorsCreate,

} from "../../../util/Permissions"

export default {
    components: {VuePagination},
    name: "vendor",
    data() {
        return {
            id: "",
            event_submit: false,
            page : 1,
        };
    },
    created() {
        this.$store.dispatch('Vendor/setVendors',1);
        this.$store.dispatch("Vendor/clearFormData");
    },
    computed: {
        canCustomerVendorsCreate,
        ...mapState({
            vendorList: state => {
                return state.Vendor.vendorList;
            },
            search : state=>{
                return state.Vendor.search;
            },
            dataPaginate:state=>{
                return state.Vendor.dataPaginate;
            },
        })
    },
    methods: {
        //API
        updateData(id) {
            let route = this.$router.resolve({
                name: "vendor-information",
                query: {id:window.btoa(id)}
            });
            window.open(route.href,'_blank');
            // this.$router.push({
            //     name: "vendor-information",
            //     params: { id }
            // });
        },
        searchData(page) {
            this.event_submit = true;
            let data ={
                page : page,
                keyword: this.search.keyword
            };
            this.$store.dispatch('Vendor/search',data);
        },
        getVendorPage(){
            this.page = this.dataPaginate.current_page;
            let data ={
                page : this.page,
                keyword: this.search.keyword
            };
            //paginate search
            if(this.event_submit){
                this.searchData(this.page);
            }
            //paginate get data
            else{
                this.$store.dispatch('Vendor/setVendors',this.page)
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 760px),
    (min-device-width: 768px) and (max-device-width: 1024px) {
    /* Force table to not be like tables anymore */
    table,
    thead,
    tbody,
    th,
    td,
    tr {
        display: block;
    }

    /* Hide table headers (but not display: none;, for accessibility) */
    thead tr {
        position: absolute;
        top: -9999px;
        left: -9999px;
    }

    tr {
        border: 1px solid #ccc;
    }

    td {
        /* Behave  like a "row" */
        border: none;
        border-bottom: 1px solid #eee;
        position: relative;
        padding-left: 50%;
    }

    td:before {
        /* Now like a table header */
        position: absolute;
        /* Top/left values mimic padding */
        top: 6px;
        left: 6px;
        width: 45%;
        padding-right: 10px;
        white-space: nowrap;
    }
    td:nth-of-type(1):before {
        content: "รหัสผู้จัดจำหน่าย";
    }
    td:nth-of-type(2):before {
        content: "ชื่อ-นามสกุล";
    }
    td:nth-of-type(3):before {
        content: "ที่อยู่";
    }
    td:nth-of-type(4):before {
        content: "เบอร์โทรศัพท์";
    }
    td:nth-of-type(5):before {
        content: "อีเมล";
    }
    td:nth-of-type(6):before {
        content: "Sale";
    }
    td:nth-of-type(7):before {
        content: "แก้ไข / ลบ";
    }
}
</style>
